import { Snackbar, Alert } from "@mui/material";
import styles from "./Snackbar.module.scss";

const WarningSnackbar = ({ open, message, onClose }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Alert
        onClose={onClose}
        severity="warning"
        variant="filled"
        className={`${styles.alert} ${styles.warningAlert}`}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default WarningSnackbar;
